import { useCallback } from 'react';
import { List, ListItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Select from '@/components/common/Select/Select';
import useOrganisation from '@/hooks/useOrganisation';

function AppMenuOrganisationSwitch() {
  const { selectedOrganisationId, switchOrganisation, allowedOrganisations } = useOrganisation();
  const navigate = useNavigate();

  const switchOrgAndNavigate = useCallback(
    (orgId: string) => {
      localStorage.removeItem('redirectUrl');
      navigate('/', { replace: true });
      switchOrganisation(orgId);
    },
    [switchOrganisation, navigate]
  );

  return allowedOrganisations?.length >= 2 ? (
    <List>
      <ListItem>
        <Select
          name="organisationId"
          label="Organisation"
          options={allowedOrganisations}
          value={selectedOrganisationId}
          displayFunction={(value) => value?.organisationName ?? ''}
          valueFunction={(value) => value?.organisationId ?? ''}
          onChange={switchOrgAndNavigate}
          required={true}
          fullWidth={true}
          placeHolder="Select an option"
        ></Select>
      </ListItem>
    </List>
  ) : (
    <></>
  );
}

export default AppMenuOrganisationSwitch;
